.av-media-player {
  .av-card.av-card-floating {
    width: auto;
    margin-bottom: calc($container-height + 10px);
    video {
      width: var(--av-queue-video-width);
      height: var(--av-queue-video-height);
    }
    iframe,
    video {
      float: left;
    }
  }
  .av-media-player-control {
    position: absolute;
    bottom: 4px;
    right: 4px;
  }
}
